import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    categoryList: {
        requesting: false,
        items: [],
        error: null,
        success: false,
        filters: {},
    },
    
    hyvidStoreDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    merchantList: {
        requesting: false,
        items: [],
        error: null,
        success: false,
        filters: {},
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    },
    merchantDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    voucherList: {
        requesting: false,
        items: [],
        error: null,
        success: false,
        filters: {},
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    },
    cartDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },

  };

export const hyvidStoreSlice = createSlice({
  name: 'hyvidStore',
  initialState,
  reducers: {
    getCategoryList: (state, action) => {
        state.categoryList.requesting = true;
        state.categoryList.error = null;
        state.categoryList.items = [];
        state.categoryList.success = false;
        state.categoryList.filters = action.payload;
    },
    getCategoryListSuccess: (state, action) => {
        state.categoryList.requesting = false;        
        state.categoryList.items = action.payload;
        state.categoryList.success = true; 
    },
    getCategoryListFail: (state, action) => {        
        state.categoryList.requesting = false;
        state.categoryList.error = action.payload;
    },
    getMerchantList: (state, action) => {
        state.merchantList.requesting = true;
        state.merchantList.error = null;
        state.merchantList.items = [];
        state.merchantList.success = false;
        state.merchantList.filters = action.payload;
    },
    getMerchantListSuccess: (state, action) => {
        state.merchantList.requesting = false;        
        state.merchantList.items = action.payload;
        state.merchantList.success = true; 
    },
    getMerchantListFail: (state, action) => {        
        state.merchantList.requesting = false;
        state.merchantList.error = action.payload;
    },
    getMerchantDetails: (state) => {
        state.merchantDetails.requesting = true;
        state.merchantDetails.error = null;
        state.merchantDetails.success = false;
    },
    getMerchantDetailsSuccess: (state, action) => {
        state.merchantDetails.requesting = false;        
        state.merchantDetails.data = action.payload;
        state.merchantDetails.success = true; 
    },
    getMerchantDetailsFail: (state, action) => {        
        state.merchantDetails.requesting = false;
        state.merchantDetails.error = action.payload;
    },
    getVoucherList: (state, action) => {
        state.voucherList.requesting = true;
        state.voucherList.error = null;
        state.voucherList.items = [];
        state.voucherList.success = false;
        state.voucherList.filters = action.payload;
    },
    getVoucherListSuccess: (state, action) => {
        state.voucherList.requesting = false;        
        state.voucherList.items = action.payload;
        state.voucherList.success = true; 
    },
    getVoucherListFail: (state, action) => {        
        state.voucherList.requesting = false;
        state.voucherList.error = action.payload;
    },

    getMyActiveCart: (state) => {
        state.cartDetails.requesting = true;
        state.cartDetails.error = null;
        state.cartDetails.success = false;
    },
    getMyActiveCartSuccess: (state, action) => {
        state.cartDetails.requesting = false;        
        state.cartDetails.data = action.payload;
        state.cartDetails.success = true; 
    },
    getMyActiveCartFail: (state, action) => {        
        state.cartDetails.requesting = false;
        state.cartDetails.error = action.payload;
    },

    doAddToCart: (state) => {
        state.cartDetails.requesting = true;
        state.cartDetails.error = null;
        state.cartDetails.success = false;
    },
    doAddToCartSuccess: (state, action) => {
        state.cartDetails.requesting = false;        
        state.cartDetails.data = action.payload;
        state.cartDetails.success = true; 
    },
    doAddToCartFail: (state, action) => {        
        state.cartDetails.requesting = false;
        state.cartDetails.error = action.payload;
    },
    // getHyvidStoreDetails: (state) => {
    //     state.hyvidStoreDetails.requesting = true;
    //     state.hyvidStoreDetails.error = null;
    //     state.hyvidStoreDetails.data = null;
    //     state.hyvidStoreDetails.success = false; 
    // },
    // getHyvidStoreDetailsSuccess: (state, action) => {
    //     state.hyvidStoreDetails.requesting = false;
    //     state.hyvidStoreDetails.data = action.payload;
    //     state.hyvidStoreDetails.success = true; 
    // },
    // getHyvidStoreDetailsFail: (state, action) => {        
    //     state.hyvidStoreDetails.requesting = false;
    //     state.hyvidStoreDetails.error = action.payload;
    // },
    // doHyvidStoreCreate: (state) => {
    //     state.hyvidStoreDetails.requesting = true;
    //     state.hyvidStoreDetails.error = null;
    //     state.hyvidStoreDetails.data = null;
    //     state.hyvidStoreDetails.success = false; 
    // },
    // doHyvidStoreUpdate: (state) => {
    //     state.hyvidStoreDetails.requesting = true;
    //     state.hyvidStoreDetails.error = null;
    //     state.hyvidStoreDetails.data = null;
    //     state.hyvidStoreDetails.success = false; 
    // },
    // doHyvidStoreDelete: (state) => {
    //     state.hyvidStoreDetails.requesting = true;
    //     state.hyvidStoreDetails.error = null;
    //     state.hyvidStoreDetails.data = null;
    //     state.hyvidStoreDetails.success = false; 
    // },

    // doHyvidStoreReset: (state) => {		
    //   state.hyvidStoreDetails.data = null;
    // },
  },
})

export const { 
    getCategoryList, getCategoryListSuccess, getCategoryListFail,
    getVoucherList, getVoucherListSuccess, getVoucherListFail,
    getMerchantList, getMerchantListSuccess, getMerchantListFail,
    getMerchantDetails, getMerchantDetailsSuccess, getMerchantDetailsFail,
    doAddToCart, doAddToCartSuccess, doAddToCartFail,
    getMyActiveCart, getMyActiveCartSuccess, getMyActiveCartFail,
    // getHyvidStoreDetails, getHyvidStoreDetailsSuccess, getHyvidStoreDetailsFail,
    // doHyvidStoreCreate, doHyvidStoreUpdate, doHyvidStoreDelete,
    // doHyvidStoreReset,
} = hyvidStoreSlice.actions

export default hyvidStoreSlice.reducer